import { Navigate } from "react-router-dom";

const UserType = {
  Admin: "Admin",
  User: "User",
  Staff: "Staff",
  GateKeeper: "GateKeeper",
  Subadmin: "SubAdmin"
};

const RoleProtected = ({ allowedRoles = [], children }) => {
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");

  // ✅ 1. Not logged in → go to login page
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // ✅ 2. Role not allowed → redirect to role-specific home
  if (!allowedRoles.includes(userType)) {
    switch (userType) {
      case UserType.GateKeeper:
        return <Navigate to="/scan-qr-code" replace />;
      case UserType.Staff:
        return <Navigate to="/all-temp-visitor" replace />;
      case UserType.Admin:
        return <Navigate to="/dashboard" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  // ✅ 3. Role allowed → render the protected content
  return children;
};

export default RoleProtected;
